import { IHocLaiThiLaiRequest } from "../../model/request/hoc-lai-thi-lai/IHocLaiThiLaiRequest";
import { apiClient } from "../apiClient";

const HOC_LAI_THI_LAI_ENDPOINT = "hoc-lai-thi-lai";
export const hocLaiThiLaiApi = {
    SelectByLop: (request: IHocLaiThiLaiRequest) => apiClient.post(`${HOC_LAI_THI_LAI_ENDPOINT}/tong-hop`, request),
}